<template>
  <div>
    <div class="navbar menu stick">
      <div class="navbar hidden-sm-and-down container pt-0 pb-0" id="menu">
        <!-- INICIO MENU -->
        <v-flex sm12 row wrap align="center" class="row-ajust" left style="margin-left: 0px; margin-right: 0px">
          <v-flex xs12 sm11 row class="row-ajust">
            <v-flex sm1 xs12 style="align-self: center;">
              <v-btn text small @click="redireccionar">Inicio</v-btn>
            </v-flex>
            <v-flex sm11 xs12 style="align-items: center">
              <v-tabs show-arrows next-icon="fa-caret-right" prev-icon="fa-caret-left">
                <div
                  v-for="padre in gopciones_padre"
                  :key="padre.idopcion"
                  style="align-self: center;"
                >
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        text
                        class="buttonletter iconajust font-weight-light"
                        v-on="on"
                        @click="seleccionar(padre.idopcion)"
                      >
                        <!-- <v-icon small left class="iconajust">{{padre.clase}}</v-icon> -->
                        {{padre.titulo}}
                        <v-icon v-if="padre.hijos.length > 0" right>mdi-menu-down</v-icon>
                      </v-btn>
                    </template>
                    <div v-if="padre.hijos.length > 0">
                      <v-list dense>
                        <v-subheader>{{padre.titulo}}</v-subheader>
                        <v-list-item-group color="primary">
                          <v-list-item 
                            v-for="item in filtrarhijos(padre.hijos)"
                            :key="item.idopcion"
                          >
                            <v-list-item-content @click="seleccionar(item.idopcion)">
                              <v-list-item-title class="aclaratorialist" v-text="item.titulo"></v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </div>
                  </v-menu>
                </div>
              </v-tabs>
            </v-flex>
          </v-flex>
          <v-flex xs12 sm1 style="align-self: center; text-align-last: end;" left>
            <div class="text-xs-right">
              <div v-if="!cargado">
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn text class="align-self-center" @click="login" v-on="on" id="a-login">
                      <v-icon small left>icon-user-lock</v-icon>Ingresar
                    </v-btn>
                  </template>
                </v-menu>
              </div>
              <div v-if="cargado">
                <v-menu
                  :close-on-content-click="false"
                  :nudge-width="150"
                  offset-x
                  v-model="menutoolp"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" fab x-small color="primary">{{usuario.iniciales}}</v-btn>
                  </template>
                  <v-card>
                    <div class="content" text>
                      <v-list>
                        <v-list-item>
                          <v-list-item-avatar color="primary">
                            <span class="text-white">{{usuario.iniciales}}</span>
                          </v-list-item-avatar>

                          <v-list-item-content>
                            <v-list-item-title>{{usuario.nombre}}</v-list-item-title>
                            <v-list-item-subtitle>{{usuario.login}}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>

                      <v-divider></v-divider>

                      <v-list>
                        <v-list-item>
                          <v-list-item-title>Entidad: {{usuario.nombreentidad}}</v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-title>Sector: {{usuario.nombresector}}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text @click="salir">Cerrar sesión</v-btn>
                      </v-card-actions>
                    </div>
                  </v-card>
                </v-menu>
              </div>
            </div>
          </v-flex>
        </v-flex>
      </div>
      <div class="hidden-md-and-up">
        <div class="navbar menu stick">
          <v-list dense>
            <v-list-group prepend-icon="mdi-home" :value="vliststate" v-model="vliststate" append-icon="undefined">
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>Inicio</v-list-item-title>
                </v-list-item-content>
              </template>

              <div v-for="padre in gopciones_padre" :key="padre.idopcion">
                <v-list-group sub-group :value="vliststate" append-icon="undefined" prepend-icon="" >
                    <v-list-item slot="activator">
                      <v-list-item-action>
                        <v-icon slot="appendIcon" :color="!padre.hijos || padre.hijos.length ? 'silver' : 'white'">mdi-menu-down</v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title @click="seleccionar(padre.idopcion)">{{padre.titulo}}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>                  
                  <div v-if="padre.hijos.length > 0">
                    <v-list-item-group color="primary">
                      <v-list-item
                        v-for="subItem in filtrarhijos(padre.hijos)"
                        :key="subItem.idopcion"
                      >
                        <v-list-item-content>
                          <v-list-item-title
                            v-text="subItem.titulo"
                            @click="seleccionar(subItem.idopcion)"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </div>
                </v-list-group>
              </div>

              <v-list-item v-if="!cargado">
                <v-list-item-icon>
                  <v-icon>icon-user-lock</v-icon>
                </v-list-item-icon>
                <v-list-item-title @click="login">Login</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="cargado">
                <v-list-item-icon>
                  <v-icon>icon-user</v-icon>
                </v-list-item-icon>
                <v-list-item-title @click="salir">Salir</v-list-item-title>
              </v-list-item>
            </v-list-group>
          </v-list>
        </div>
      </div>
    </div>
    <div class="container pt-0 pb-0">
      <v-divider></v-divider>
      <miga></miga>
    </div>

    <v-dialog v-model="show" width="350" persistent>
      <v-form
        ref="form"
        v-model="valid"
        v-if="(MesaggeInfo.codigoRespuesta=== undefined || MesaggeInfo.codigoRespuesta===''  )  && !cargado && cambioclave===false && olvidoclave===false"
      >
        <v-card>
          <v-card-title>
            <v-btn icon @click="cerrarlogin" right>
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row dense>
                <v-col cols="12" xs="12" sm="12" md="12">
                  <div class="text-center mb-3">
                    <i
                      class="icon-user-lock icon-1x text-blue border-2 border-main rounded-round p-3 mb-3"
                    ></i>
                    <h3 class="text-title">Ingreso al sistema</h3>
                    <span class="d-block text-muted mb-0">Diligencie sus datos de acceso:</span>
                  </div>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    prepend-icon="icon-user"
                    label="Nombre de usuario"
                    v-model="username"
                    v-validate="'required'"
                    data-vv-name="usuario"
                    :error-messages="errors.collect('usuario')"
                    autofocus
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    label="Clave"
                    prepend-icon="icon-key"
                    v-on:keyup.13="autenticar"
                    v-validate="'required'"
                    data-vv-name="clave"
                    :error-messages="errors.collect('clave')"
                    type="password"
                    v-model="password"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <a
                  class="enlaceprimario"
                  v-on:click="olvidoclave=true"
                  color="secondary"
                >Olvidé mi contraseña</a>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary" :disabled="!valid || !ingresar" @click="autenticar">
              INGRESAR
              <v-icon right>icon-circle-right2</v-icon>
            </v-btn>
            <v-btn color="secondary" @click="cambioclave = true">
              CAMBIAR CLAVE
              <v-icon right>icon-circle-right2</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
      <v-form
        ref="form2"
        v-model="validcambio"
        v-if="MesaggeInfo.codigoRespuesta==='E0012' || MesaggeInfo.codigoRespuesta==='E0013' || (cambioclave===true && olvidoclave===false)"
      >
        <v-card>
          <v-card-title>
            <v-btn icon @click="cerrarlogin" right>
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row dense>
                <v-col cols="12" xs="12" sm="12" md="12">
                  <div class="text-center mb-3">
                    <i
                      class="icon-user-lock icon-1x text-blue border-2 border-main rounded-round p-3 mb-3"
                    ></i>
                    <h3 class="text-title">Ingreso al sistema</h3>
                    <span class="d-block text-muted mb-0">Modifique sus datos de acceso:</span>
                  </div>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    prepend-icon="icon-user"
                    label="Nombre de usuario"
                    v-model="username"
                    v-validate="'required'"
                    data-vv-name="usuario"
                    :error-messages="errors.collect('usuario')"
                    autofocus
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    label="Clave actual"
                    prepend-icon="icon-key"
                    v-on:keyup.13="cambiar"
                    v-validate="'required'"
                    data-vv-name="clave"
                    :error-messages="errors.collect('clave')"
                    type="password"
                    v-model="password"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        label="Nueva clave"
                        keyup.13="cambiar"
                        ref="nueva"
                        type="password"
                        v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@!._%*?&])([A-Za-z\d$@!._%*?&]|[^ ]){8,}$/ }"
                        v-model="nuevaclave"
                        v-on="on"
                        data-vv-name="nueva"
                        :error-messages="errors.collect('nueva')"
                      ></v-text-field>
                    </template>
                    <span>
                      La nueva clave debe tener mínimo 8 caracteres, debe contener por lo menos una letra mayúscula,
                      <br />una letra minúscula, un número y uno de los siguientes caracteres: $@!._%*?&amp;
                    </span>
                  </v-tooltip>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    label="Confirmar clave"
                    v-on:keyup.13="cambiar"
                    type="password"
                    v-model="confirmarclave"
                    v-validate="'required|confirmed:nueva'"
                    data-vv-name="confirmar"
                    :error-messages="errors.collect('confirmar')"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary" :disabled="!validcambio || !actualizar" @click="cambiarclave">
              ACTUALIZAR
              <v-icon right>icon-circle-right2</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
      <v-form ref="form3" v-model="validolvido" v-if="olvidoclave===true && cambioclave===false">
        <v-card>
          <v-card-title>
            <v-btn icon @click="cerrarlogin" right>
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row dense>
                <v-col cols="12" xs="12" sm="12" md="12">
                  <div class="text-center mb-3">
                    <i
                      class="icon-user-lock icon-1x text-blue border-2 border-main rounded-round p-3 mb-3"
                    ></i>
                    <h3 class="text-title">Olvido de contraseña</h3>
                    <span
                      class="d-block text-muted mb-0"
                    >Ingrese su correo registrado para reestablecer su contraseña:</span>
                  </div>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    prepend-icon="icon-user"
                    label="Correo electrónico"
                    v-model="username"
                    v-validate="'required|email'"
                    data-vv-name="usuario"
                    :error-messages="errors.collect('usuario')"
                    autofocus
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary" v-on:click="olvidoclave=false">
              CANCELAR
              <v-icon right>icon-circle-right2</v-icon>
            </v-btn>
            <v-btn
              color="secondary"
              :disabled="!validolvido || username===''"
              v-on:click="solicitarolvido"
            >
              ENVIAR
              <v-icon right>icon-circle-right2</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="cerrar" width="350">
      <v-form ref="form">
        <v-card>
          <v-card-title>
            <v-btn icon @click="cerrar = false" right v-if="0===8">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <div class="text-center">
              <v-btn color="secondary" right @click="salir">
                CERRAR SESIÓN
                <v-icon right>exit</v-icon>
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>
    <v-snackbar v-model="snack1" :timeout="8000" :color="MesaggeInfo.color">
      {{ this.MesaggeInfo.mensajeRespuesta }} {{this.MesaggeInfo.codigoRespuesta}}
      <v-btn text @click="snack1 = false">Cerrar</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import navitem from "./navitem";
import miga from "./miga";
import { filter } from "@amcharts/amcharts4/.internal/core/utils/Iterator";
import { Filter } from "@amcharts/amcharts4/core";
// Función para el menu estático
let observer = new IntersectionObserver(
  function (entries) {
    if (entries[0].intersectionRatio === 0)
      document.querySelector("#menu").classList.add("sticked");
    else if (entries[0].intersectionRatio === 1)
      document.querySelector("#menu").classList.remove("sticked");
  },
  { threshold: [0, 1] }
);

// Componente
export default {
  name: "global-NewMenu",
  components: { navitem, miga },
  data() {
    return {
      vliststate: false,
      menutoolp: false,
      show: false, // Propiedad para mostrar el modal login
      cerrar: false,
      cambioclave: false,
      olvidoclave: false,
      validolvido: false,
      username: "",
      password: "",
      nuevaclave: "",
      confirmarclave: "",
      cargado: null,
      valid: false,
      validcambio: false,
      usuario: null,
      snack1: false,
      snackColor: "",
      veringresar: false,
      snackText: "",
      lazy: false,
      rules: {
        required: (value) => !!value || "Requerido",
        igual: () =>
          this.confirmarclave === this.nuevaclave || "Clave no válida",
      },
      MesaggeInfo: [{ codigoRespuesta: "", color: "", mensajeRespuesta: "" }],
      currentItem: "tab-Web",
      item: 1,
      items: [
        { text: "Real-Time", icon: "mdi-clock" },
        { text: "Audience", icon: "mdi-account" },
        { text: "Conversions", icon: "mdi-flag" },
      ],
      dictionary: {
        custom: {
          usuario: {
            required: () => "El nombre de usuario no puede estar en blanco",
            email: () => "El correo electrónico es inválido",
          },
          clave: {
            required: () => "La clave no puede estar en blanco",
          },
          nueva: {
            required: () => "La nueva clave no puede estar en blanco",
            regex: () => "Valor de nueva clave no es válida",
          },
          confirmar: {
            required: () => "La confirmación de clave no puede estar en blanco",
            confirmed: () => "Las contraseñas ingresadas no coinciden",
          },
        },
      },
    };
  },
  $_veeValidate: {
    validator: "new",
  },
  created: function () {
    this.cargado = this.gcargadolocal;
    if (this.cargado) {
      this.$store.dispatch("usuario/reload_usuario");
      this.usuario = JSON.parse(localStorage.usuario);
    }
    this.recalcular();
  },
  computed: {
    ...mapGetters(["gopciones", "gopciones_padre"]),
    ...mapGetters("usuario/", [
      "gexisteerror",
      "gerror",
      "gcargado",
      "gcargadolocal",
    ]),
    ...mapGetters("mensaje", ["ginformation", "gnodata"]),
    ingresar() {
      return this.password && this.username;
    },
    actualizar() {
      return this.nuevaclave && this.confirmarclave;
    },
  },
  methods: {
    ...mapActions(["get_porusuario", "get_publico", "cls_opciones"]),
    ...mapActions("usuario/", [
      "post_autenticarusuario",
      "post_cambiarclaveusuario",
      "put_olvidoclave",
      "clean_error",
      "clean_usuario",
    ]),
    cerrarlogin() {
      this.show = false;
      this.cambioclave = false;
    },
    login: function () {
      this.vliststate = false;
      this.show = true;
      this.clean_error();
      this.username = "";
      this.olvidoclave = false;
      this.validolvido = true;
      this.password = "";
      this.MesaggeInfo = [
        { codigoRespuesta: "", color: "", mensajeRespuesta: "" },
      ];
      this.valid = true;
      this.validcambio = true;
      if (this.$refs.form != undefined) {
        this.$refs.form.resetValidation();
      }
    },
    recalcular() {
      if (this.cargado) {
        this.get_porusuario();
      } else {
        this.get_publico();
      }
    },
    autenticar() {
      let payload = {
        login: this.username.toLowerCase(),
        clave: this.password,
      };
      this.post_autenticarusuario(payload);
    },
    cambiarclave() {
      let payload = {
        login: this.username,
        clave: this.password,
        cambioclave: this.nuevaclave,
      };
      this.post_cambiarclaveusuario(payload);
    },
    solicitarolvido() {
      let payload = { login: this.username.toLowerCase() };
      this.put_olvidoclave(payload);
      this.show = false;
    },
    salir() {
      this.menutoolp = false;
      this.clean_usuario();
    },
    datousuario() {
      return JSON.parse(localStorage.usuario);
    },
    seleccionar(btn) {
      let opcion = this.gopciones.filter((p) => p.idopcion == btn)[0];
      if (opcion.link !== null ) {
        this.vliststate = false;
        if (opcion.link.toUpperCase().includes("REPORTE_")) {
          let cad = opcion.link.replace("REPORTE_", "");
          let global = JSON.parse(unescape(process.env.PACKAGE_JSON)).global;
          let env = global[global.env];
          this.$aes.setKey(env.path.secret);
          let cifra = this.$aes.encrypt(cad);
          cifra = cifra.replace(/\//g, "AbcYq");
          cifra = cifra.replace(/\+/g, "qYcbA");
          localStorage.setItem("reporte", opcion.titulo);
          window.open("/reporte/" + cifra, "_self");
        } else {
          if (!opcion.link.toUpperCase().includes("HTTP")) {
            console.log('opcion.link', opcion.link)
            this.$router.push(opcion.link);
          } else {
            window.open(opcion.link, "_blank");
          }
        }
      } else if (opcion.hijos.length == 0) {
        this.vliststate = false;
      }
    },
    filtrarhijos(Elementoshijos) {
      let HijosFiltradas = Elementoshijos.filter((record) => {
        if (record.visible == true) {
          return record;
        }
      });
      return HijosFiltradas;
    },
    redireccionar() {
      this.$router.push("/inicio");
    },
  },
  mounted: function () {
    this.$validator.localize("es", this.dictionary);
    observer.observe(document.querySelector("#menu-top"));
  },
  beforeDestroy() {
    this.$validator.pause();
  },
  watch: {
    gcargado: function () {
      if (!this.cargado && this.gcargado) {
        this.show = false;
        this.$validator.pause();
        this.cargado = this.gcargado;
        this.username = "";
        this.password = "";
        this.usuario = JSON.parse(localStorage.usuario);
        this.cls_opciones();
        this.get_porusuario().then(() => {
          console.log(JSON.parse(localStorage.usuario).opciondefecto);
          this.$router.push(JSON.parse(localStorage.usuario).opciondefecto);
        });
      } else {
        if (this.cargado && !this.gcargado) {
          console.log("sale?");
          let payload = { botonnuevo: 1 };
          this.$store.dispatch("barra/aseleccionar", payload);
          this.get_publico().then(() => {
            console.log("debe salir");
            this.$router.go("/inicio");
          });
        }
      }
    },
    ginformation() {
      if (!this.gcargado) {
        this.MesaggeInfo = this.ginformation;
        console.log(this.MesaggeInfo.mensajeRespuesta);
        this.snack1 = true;
      }
    },
  },
};
</script>